<template>
	<TemplateHero v-bind="props">
		<slot />
	</TemplateHero>
</template>

<script lang="ts" setup>
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import type { ImageType } from '#base/core/types/ImageType';

const props = defineProps<{
	heroImage: ImageType;
	pageTitle: string;
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
}>();
</script>
